import { useEffect, useState } from "react";
import Folder from "./Folder";
import { FaXmark } from "react-icons/fa6";
import { useGetFolderQuery } from "../../dataApiSlice";
import { useDispatch, useStore } from "react-redux";
import { usePublishWorkbookMutation } from "../../dataApiSlice";
import { setWorkbookProperty } from "../../WorkbookSlice";
import LoadingIndicator from "../../../../components/BasicComponents/LoadingIndicator";

export default function PublishWorkbook({
  closeModal,
  moveFolderModal,
  setNewParentFolderId,
  handleMove,
}) {
  const value = useStore().getState();
  // // console.log(value.Workbook.present);
  // // console.log(moveFolderModal);
  // console.log(dataSourceID);
  const [workbookName, setWorkbookName] = useState(
    value.Workbook.present.name
  );
  // // console.log(workbookName);
  // console.log(dataSourceID);
  const [folderId, setFolderId] = useState(null);
  // console.log(folderId);
  const [check, setCheck] = useState(true);
  // console.log(check);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      setWorkbookProperty({
        itemInArray: false,
        key: "name",
        value: workbookName,
      })
    );
  }, [workbookName]);

  useEffect(() => {
    if (folderId && setNewParentFolderId) {
      setNewParentFolderId(folderId);
    }
  }, [folderId]);

  const handleFileName = (e) => {
    setWorkbookName(e.target.value);
  };
  const staticFolderId = "root";
  const {
    data: folderStructure,
    isSuccess,
    isLoading,
    isError,
    error,
  } = useGetFolderQuery(staticFolderId);
  let PublishContent = null;
  if (isLoading) {
    PublishContent = <LoadingIndicator />;
  }
  if (isError) {
    // console.log(error);
    PublishContent = (
      <span className="text-red-700">
        Error while fetching folder: {error?.data?.error}
      </span>
    );
  }
  if (isSuccess) {
    // console.log(folderStructure);
    PublishContent = (
      <>
        {Object.keys(folderStructure).map((key) => (
          <Folder
            key={key}
            folder={folderStructure[key]}
            staticFolderId={key}
            setNewParentFolderId={setNewParentFolderId}
            setFolderId={setFolderId}
            folderId={folderId}
          />
        ))}
      </>
    );
  }

  const {
    _id: draftId,
    commonFilters,
    hierarchy,
    sheets,
    name,
    selectedSheetId,
    calculatedFields,
    dataSources,
  } = value.Workbook.present;
  // console.log(dataSources);
  const [
    publishWorkbook,
    {
      data,
      isError: isPusblishError,
      isLoading: isPublishLoading,
      isSuccess: isPublishSuccess,
      error: publishError,
    },
  ] = usePublishWorkbookMutation();

  if (isPusblishError) {
    // console.log(publishError);
  }
  useEffect(() => {
    // Check if all required fields are filled
    // console.log(folderId);
    // console.log(dataSourceID);
    // console.log(workbookName);
    const condition = moveFolderModal ? folderId : workbookName && folderId;
    if (condition) {
      setCheck(false); // Enable the button
    } else {
      setCheck(true); // Disable the button
    }
  }, [workbookName, folderId]);

  const handlePublish = () => {
    const chartSheetsArray = sheets.filter(
      (sheet) => sheet.sheetType === "chart"
    );
    // console.log("Chart Sheets Array:", chartSheetsArray);

    const dashboardSheetsArray = sheets.filter(
      (sheet) => sheet.sheetType === "dashboard"
    );
    // console.log(
    //   "Dashboard Sheets Array (Before Update):",
    //   dashboardSheetsArray
    // );

    const chartSheetMap = chartSheetsArray.reduce((map, chartSheet) => {
      map[chartSheet.ID] = chartSheet.SheetName;
      return map;
    }, {});
    const updatedDashboardSheetsArray = dashboardSheetsArray.map(
      (dashboardSheet) => {
        const updatedSheetsArray = dashboardSheet.SheetsArray.map((sheet) => ({
          ...sheet,
          SheetName: chartSheetMap[sheet.Sheetid] || sheet.SheetName,
        }));

        return {
          ...dashboardSheet,
          SheetsArray: updatedSheetsArray,
        };
      }
    );

    // console.log(
    //   "Dashboard Sheets Array (After Update):",
    //   updatedDashboardSheetsArray
    // );

    // Prepare the final sheets array
    const finalSheets = [
      ...chartSheetsArray, // Include chart sheets as is
      ...updatedDashboardSheetsArray, // Include updated dashboard sheets
    ];

    // console.log({
    //   draftId,
    //   icon: "null",
    //   name: workbookName,
    //   commonFilters,
    //   hierarchy,
    //   calculatedFields,
    //   folderId,
    //   sheets: finalSheets,
    //   selectedSheetId,
    //   dataSources,
    // });

    // Call publishWorkbook with the updated sheets
    publishWorkbook({
      draftId,
      icon: "null",
      name: workbookName,
      commonFilters,
      hierarchy,
      calculatedFields,
      folderId,
      sheets: finalSheets,
      selectedSheetId,
      dataSources,
    });
  };

  if (isPublishSuccess) {
    // console.log(data);
    const publishId = [data.publishId];
    // console.log(publishId);
    dispatch(
      setWorkbookProperty({
        itemInArray: false,
        key: "publishId",
        value: publishId,
      })
    );
    closeModal();
  }
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      if (moveFolderModal) {
        handleMove();
      } else {
        handlePublish();
      }
    }
  };

  const modalHeight = moveFolderModal ? 44 : 54;
  const adjustedHeight = isPusblishError ? 60 : modalHeight;

  return (
    <main
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onKeyDown={handleKeyDown}
    >
      {/* main-content */}
      <section
        className={`flex flex-col bg-white shadow-2xl rounded w-full max-w-md justify-between items-center gap-0`}
        style={{ height: `${adjustedHeight}%` }}
      >
        <header className="flex bg-gray-50 w-full p-2 items-center justify-between rounded-t-lg  font-medium">
          {moveFolderModal ? "Move Folder" : "Publish Workbook"}
          <button onClick={closeModal}>
            <FaXmark />
          </button>
        </header>
        <section className="w-full flex flex-col px-2 gap-2 h-[72.5%]">
          {moveFolderModal ? null : (
            <div className="">
              <label htmlFor="name" className="text-sm font-medium">
                Name
              </label>
              <input
                type="text"
                name="name"
                id="name"
                value={workbookName}
                className="border px-4 py-2 w-full focus:outline-none focus:ring focus:ring-blue-300"
                onChange={handleFileName}
              />
            </div>
          )}
          <div className="">
            <span className="text-sm font-medium">Location</span>
            <div className="h-48 border overflow-y-auto p-2 ">
              {PublishContent}
            </div>
          </div>
        </section>
        <footer className="flex justify-end items-center w-full p-2 bg-gray-50">
          <button
            className="border py-1 px-2 tracking-wide mr-2 text-gray-700 hover:bg-gray-200"
            onClick={closeModal}
          >
            Close
          </button>
          <button
            className={`border py-1 px-2 tracking-wide ${
              check ? "bg-gray-400 text-black" : "bg-blue-950 text-white"
            }`}
            onClick={() => {
              if (moveFolderModal) {
                handleMove();
              } else {
                handlePublish();
              }
            }}
            disabled={check}
          >
            {moveFolderModal ? "Move" : "Publish"}
          </button>
        </footer>
        {isPusblishError ? (
          <p className="text-red-500 ml-1 ">{publishError?.data?.message}</p>
        ) : null}
      </section>
    </main>
  );
}
